// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"c042f30c","890":"e8ab80c8","920":"db232dfd"}[chunkId] + ".chunk.js";
};